import React, {useContext} from 'react';

const PipelineSettingsContext = React.createContext();

export const usePipelineSettingsContext = () =>
  useContext(PipelineSettingsContext);

export default PipelineSettingsContext;
